<template>
  <footer class="py-4 brand-bgcolor">
      <div class="navbar">
        <div class="col-sm-12 p-0 text-center">
      <ul class="list-inline mb-0" id="footer-nav">
        <li class="list-inline-item">
              <router-link
                to="/Home"                
                aria-label="Home"
                alt="Home"
                >{{ $t('Footer.Home') }}
              </router-link>
            </li>
            <li class="list-inline-item">
              <router-link
                to="/ReceiptTroubleshooting"                
                aria-label="Receipt Troubleshooting"
                alt="Receipt Troubleshooting"
                >{{$t('Footer.ReceiptTroubleshooting')}}
              </router-link>
            </li>
      
        <li class="list-inline-item" v-html="$t('Footer.T&CLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.FAQlink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.CookiePreference')">              
            </li>
        <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
        </li>        
        <li class="list-inline-item" v-html="$t('Footer.SnippPrivacyPolicyLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.DNSLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">   
        </li>
      </ul>
      <p class="mt-3">
        <small
          >{{$t('Footer.copyrighttext')}} © {{ new Date().getFullYear() }} {{$t('Footer.AllrightReserved')}}</small
        >
      </p>
    </div> </div>
    <!-- <div class="footer-right ">
      <div class="footer-social-nav">
        <ul class="list-inline m-0">
          <li>
            <a
              href="#"
              class="fb-link social-icon"
              title="facebook"
              target="_blank"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="twitter-link social-icon"
              title="twitter"
              target="_blank"
            >
              <i class="fab fa-square-x-twitter"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="ig-link social-icon"
              title="instagram"
              target="_blank"
            >
              <i class="fab fa-instagram-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="yt-link social-icon"
              title="youtube"
              target="_blank"
            >
              <i class="fab fa-youtube-square"></i>
            </a>
          </li>
        </ul>
      </div>
     
    </div> -->
  </footer>
</template>

<script>
export default {};
</script>
<style>
@media screen and (max-width: 575px) {
  .navbar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #footer-nav li + li:before {
    content: '';
    margin-right: 0px;
  }
  footer {
    text-align: center;
  }
  footer li.list-inline-item {
    display: block;
  }
  footer li.list-inline-item {
    display: block;
  }
  .footer-social-nav {
    float: none;
  }
}
</style>

